import InputAmount from 'app/shared/components/InputAmount'
import InputField from 'app/shared/components/InputField'
import { commonToast, useToast } from 'app/shared/context/CommonUIProvider'
import { Button } from 'primereact/button'
import * as React from 'react'

const PgInputRef: React.FC = () => {
    // InputField Ref 테스트 시작 ------------------------------
    const inputFieldRef = React.useRef<HTMLInputElement>(null)
    const handleFocus = () => {
        inputFieldRef.current?.focus()
    }
    const handleText = () => {
        if (inputFieldRef.current) {
            inputFieldRef.current.value = 'TEST'
        }
    }
    // InputField Ref 테스트 끝 ------------------------------
    // InputAmount Ref 테스트 시작 ------------------------------
    //이거? 외부에 state로 사용했었나????
    const [amount, setAmount] = React.useState('0')
    const InputAmountRef = React.useRef<HTMLInputElement>(null)
    const handleAmountFocus = () => {
        InputAmountRef.current?.focus()
    }
    const handleAmountText = () => {
        if (InputAmountRef.current) {
            //onChange이벤트가 발생하지 않는다.
            InputAmountRef.current.value = '1000'
            setAmount('1000')
        }
    }
    // InputAmount Ref 테스트 끝 ------------------------------
    const { show } = useToast()
    React.useEffect(() => {
        if (inputFieldRef.current && InputAmountRef.current) {
            show({ severity: 'success', content: 'Ref ready!' })
        }
    }, [inputFieldRef.current, InputAmountRef.current])

    return (
        <>
            <p>InputField Ref 테스트</p>
            <InputField ref={inputFieldRef} />
            <Button
                className="button-basic-tint -md width-full mt-24"
                label="Focus"
                onClick={handleFocus}
            />
            <Button
                className="button-basic-tint -md width-full mt-24"
                label="Set text - 'TEST'"
                onClick={handleText}
            />
            <br />
            <p>InputAmount Ref 테스트</p>
            <InputAmount
                ref={InputAmountRef}
                label="고객1일"
                placeholder="금액 입력"
                items={[]}
                onChange={(e) => {
                    setAmount(e.target.value)
                }}
            />
            <Button
                className="button-basic-tint -md width-full mt-24"
                label="Focus"
                onClick={handleAmountFocus}
            />
            <Button
                className="button-basic-tint -md width-full mt-24"
                label="Set text - '1000'"
                onClick={handleAmountText}
            />
        </>
    )
}

export default PgInputRef
